import { render } from "./Activity.vue?vue&type=template&id=03154956&scoped=true&ts=true"
import script from "./Activity.vue?vue&type=script&lang=ts"
export * from "./Activity.vue?vue&type=script&lang=ts"

import "./Activity.vue?vue&type=style&index=0&id=03154956&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03154956"]])

export default __exports__